// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33ZZ4","inner":"Footer_inner__1IiDQ"};